import { render, staticRenderFns } from "./ListBankReturns.vue?vue&type=template&id=458eaa78"
import script from "./ListBankReturns.vue?vue&type=script&lang=js"
export * from "./ListBankReturns.vue?vue&type=script&lang=js"
import style0 from "./ListBankReturns.vue?vue&type=style&index=0&id=458eaa78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports